export default {
  root: {},
  section: {
    color: '#637381',
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};
